import { useMessages } from "next-intl";

import type { Screen0LanguageCode } from "@/features/language/language-registry";
import { getLocaleMessages, type Screen0Messages } from "@/i18n/messages";

export type TranslationStructure = Screen0Messages;

export function getTranslations(
  languageCode: Screen0LanguageCode,
): TranslationStructure {
  return getLocaleMessages(languageCode);
}

export function useScreen0Messages(): TranslationStructure {
  return useMessages() as TranslationStructure;
}
